/**
 * External dependencies
 */
import React from "react"
import { Container, Row, Col } from "react-bootstrap"

/**
 * Internal dependencies
 */
import LinkIcon from "../link-icon/link-icon"
import "./styles/_index.scss"
import ContentBlock from "../content/Content";
import { useStaticQuery, graphql } from "gatsby"
const PropertyCalloutBanner = (props) => {
  const data = useStaticQuery(graphql`
  query {
    glstrapi {
      newsBanner(publicationState: LIVE) {
        Big_Title
        Content
        Label
        Subscribe_Content
        Subscribe_Title
        Title
        Link {
          Alias
        }
      }

    }
  }
`)
  const Content = () => (
    <Row className="callout-banner__inner justify-content-lg-between bg-blue g-0 position-relative">
      <Col className="callout-banner__col position-relative">
        {data?.glstrapi?.newsBanner?.Title && <h5>{data?.glstrapi?.newsBanner?.Title}</h5>}

        <Row className="g-0 align-items-baseline">
          <Col xs={12} lg="auto">
            {/* {description && <p>{description}</p>} */}
            <ContentBlock Content={data?.glstrapi?.newsBanner?.Content} />
          </Col>

          <Col xs="auto">
            {data?.glstrapi?.newsBanner?.Label && <LinkIcon 
            
            href={"property-valuation-in-wiltshire"} text={data?.glstrapi?.newsBanner?.Label}
             />}
          </Col>
        </Row>
      </Col>
      <Col
        lg="auto"
        className="callout-banner__col d-none d-lg-block position-relative"
      >
        {data?.glstrapi?.newsBanner?.Big_Title && <h3 className="removal-text">{data?.glstrapi?.newsBanner?.Big_Title}</h3>}
      </Col>
    </Row>
  );

  return (
    <div className="callout-banner">
      {props?.addShell
        ? <Container fluid="hg">
          <Content />
        </Container>
        : <Content />
      }
    </div>
  )
}

export default PropertyCalloutBanner
